import type { Surface } from "./surface";

/** --background in index.css, as hex for the browser-chrome theme-color meta.
 * Mirrored by the no-flash inline script in index.html — keep in sync. */
export const THEME_COLOR = { light: "#faf9f6", dark: "#0c0a09" };

/** The SailGP+ page ground. No builds page holds that surface since Maintenance
 * and Parts moved to servicing.sailgp.tech (2026-09-28), so this is unused until
 * the surface plumbing is removed or reused. */
export const SGP_THEME_COLOR = "#0C0E0F";

/** Single owner of the <meta name="theme-color"> value. The surface wins over
 * the app theme while it is held, so enter -> toggle theme -> leave always
 * ends on the right colour. */
export function themeColorFor(
  resolved: "light" | "dark",
  surface: Surface | null,
): string {
  if (surface === "sgp") return SGP_THEME_COLOR;
  return THEME_COLOR[resolved];
}
